import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';

export const tipSliderApi = createApi({
  reducerPath: 'tipSliderApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['TipSlider'],
  endpoints: (builder) => ({
    getTipSliders: builder.query({
      query: (page = 1) => ({
        url: 'api/web/v1/site/tip-slider',
        method: 'GET',
        params: { page },
        tokenType: 'admin',
      }),
      providesTags: ['TipSlider'],
    }),
    addTipSlider: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/add-tip-slider',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['TipSlider'],
    }),
    updateTipSlider: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/update-tip-slider',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['TipSlider'],
    }),
    deleteTipSlider: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/delete-tip-slider',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['TipSlider'],
    }),
  }),
});

export const {
  useGetTipSlidersQuery,
  useAddTipSliderMutation,
  useUpdateTipSliderMutation,
  useDeleteTipSliderMutation,
} = tipSliderApi;
